<script setup lang="ts">
import { useContactStore } from '@/stores/contact.store';
import SignUpForm from './custom/sections/SignUpForm.vue';
import Info from './custom/ui/InfoComponent.vue';
import { Button } from '@albank/vue-ui-kit';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();

const contactStore = useContactStore();
const contact = contactStore.getContact;

const menu = ref<HTMLElement>();
const menuStatus = ref<boolean>(false);

watch(route, () => {
  if (menuStatus.value) toggleMenu();
});

const toggleMenu = () => {
  menuStatus.value = !menuStatus.value;
  if (menuStatus.value && menu.value) {
    document.body.style.overflowY = 'hidden';
    menu.value.style.transform = 'translate(0%)';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    document.body.style.overflowY = 'auto';
    if (menu.value) {
      menu.value.style.transform = 'translate(100%)';
    }
  }
};

const data = computed(() => {
  return [
    {
      title: 'SMART-библиотека им. Н.Д. Неустроева',
      subtitle: '302 ауд., 3 этаж',
      img: {
        src: '/assets/icons/map-pin.svg',
        alt: 'Локация'
      }
    },
    {
      link: `tel:${contact.value?.phone}`,
      title: `+ ${contact.value?.phone}`,
      img: {
        src: '/assets/icons/phone.svg',
        alt: 'Телефон'
      },
      copy: String(contact.value?.phone)
    },
    {
      link: `mailto:${contact.value?.email}`,
      title: `${contact.value?.email}`,
      img: {
        src: '/assets/icons/mail.svg',
        alt: 'Почта'
      },
      copy: contact.value?.email
    },
    {
      link: 'https://t.me/aeb_course',
      title: 'Присоединяйтесь к нашему каналу',
      img: {
        src: '/assets/icons/telegram.svg',
        alt: 'Телеграм'
      }
    }
  ];
});
</script>

<template>
  <header class="header" width="122">
    <RouterLink to="/">
      <img src="/assets/icons/logo.svg" alt="Логотип АЭБ" class="logo" />
    </RouterLink>

    <nav class="header-info">
      <div class="header-location" v-if="contact?.address">
        <img src="/assets/icons/map-pin.svg" alt="метка" />
        <p>{{ contact?.address }}</p>
      </div>
      <RouterLink to="/about">
        <Button class="button-secondary">О нас</Button>
      </RouterLink>
      <a :href="`mailto:${contact?.email}`" target="_blank" v-if="contact">
        <Button variant="outline" size="small">Связаться с нами</Button>
      </a>
    </nav>

    <button class="header-menu-trigger" @click="toggleMenu">
      <Transition name="fade">
        <img v-if="menuStatus" src="/assets/icons/close.svg" alt="" />
        <img v-else src="/assets/icons/menu.svg" alt="" />
      </Transition>
    </button>

    <nav class="header-menu" ref="menu">
      <div class="menu-links">
        <RouterLink to="/nextEvents">Предстоящие мероприятия</RouterLink>
        <RouterLink to="/previousEvents">Прошедшие мероприятия</RouterLink>
        <RouterLink to="/gallery">Фотографии</RouterLink>
      </div>

      <div class="menu-info" v-if="data">
        <Info v-for="item in data" :key="item.title" v-bind="item" />
        <a :href="`mailto:${contact?.email}`" target="_blank" v-if="contact">
          <Button variant="outline" size="medium">Связаться с нами</Button>
        </a>
      </div>
    </nav>
  </header>
  <SignUpForm />
</template>

<style scoped lang="scss">
.header {
  gap: 24px;
  display: flex;
  padding: 24px 0;
  align-items: center;
  justify-content: space-between;

  .logo {
    width: 122px;
    display: block;
    user-select: none;
  }

  &-location {
    gap: 8px;
    display: flex;
    align-items: center;
    font-size: var(--font-size-xs);
    color: var(--color-mono-600);
  }

  &-info {
    gap: 16px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }

  &-menu {
    left: 0;
    top: 88px;
    z-index: 3;
    width: 100%;
    display: none;
    position: fixed;
    padding: 40px 16px 80px;
    transform: translateX(100%);
    height: calc(100vh - 88px);
    transition: 0.6s all ease-in-out;
    background: var(--color-mono-0);

    @media screen and (max-width: 1024px) {
      gap: 48px;
      display: flex;
      overflow-y: auto;
      flex-direction: column;
      justify-content: space-between;
    }

    .menu-links {
      gap: 40px;
      display: flex;
      flex-direction: column;

      a {
        color: var(--color-mono-900);
        font-weight: var(--font-weight-regular);
      }
    }

    .menu-info {
      gap: 8px;
      display: flex;
      flex-direction: column;

      .button-size-medium {
        margin-top: 32px;
      }
    }

    &-trigger {
      width: 24px;
      height: 24px;
      border: none;
      display: none;
      position: relative;
      padding: 0 !important;
      background: transparent;

      img {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
      }

      @media screen and (max-width: 1024px) {
        display: block;
      }
    }
  }
}
</style>
